
import { common } from '@tencent/ceiba-base-components';
import Vue from 'vue';

const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
function getPluginName(ast, name) {
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}
const openUrl = (url, target = '_self') => {
  try {
    const isAPP = Vue.prototype.$ast.isAPP();
    const currentAstName = Vue.prototype.$ast.currentAstName();
    if (isAPP && currentAstName === 'TGCLUB'
    && window.UPBridge
    && window.UPBridge.openNewWebview) {
      const viaSource = common.tool.getQueryParams('via_source', url);
      if (viaSource) {
        // via_source 出现 “|”  导致心悦app ios跳不动
        // eslint-disable-next-line no-param-reassign
        url = common.tool.setUrlParam('via_source', encodeURIComponent(viaSource), url);
      }
      console.log('【最终事件跳转地址是】', 'url', url);
      if (url.indexOf('tgc://') > -1) {
        // 跳转闪现 app 特殊处理
        window.UPBridge.openWebPageInBrowser({ url });
      } else {
        window.UPBridge.openNewWebview({ url });
      }
      return;
    }
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = url;
      return;
    }
    const newTab = window.open('', target);
    newTab.opener = null;
    newTab.location = url;
  } catch (error) {
    console.error('openUrl fail, err=', error);
    window.location.href = url;
  }
};

// 跳转小程序跳转中转页方法
const openMpUrl = (url) => {
  try {
    const { wx } = window;
    if (!wx) {
      console.log('没有微信 jssdk 对象');
      return;
    }
    // 跳转小程序中转页
    wx.miniProgram.navigateTo({
      url,
    });
  } catch (error) {
    console.error('openMpUrl fail, err=', error);
  }
};

const openerPlugin = {
  install(Vue) {
    Vue.prototype.$opener = {
      getOpenViewSchema: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].getOpenViewSchema) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].getOpenViewSchema(params);
        }
        return;
      },
      openView: async (params) => {
        // 如果当前是小程序环境，并且需要跳转其他小程序
        if (common.platform.isMiniprogram && params.needNavigateToMiniProgram === true) {
          try {
            // 拼接小程序跳转中转页，和跳转目标的appid，path参数
            let targetUrlData = {};
            targetUrlData.type = 1;
            targetUrlData.appid = params.miniProgramAppid;
            // 目标的小程序路径传递via,via_source, trace_id参数
            targetUrlData.path = common.tool.passThroughUrlParam(params.targetPath);
            targetUrlData = encodeURIComponent(JSON.stringify(targetUrlData));
            // 处理跳转小程序中转页参数
            const targetUrl = `${params.miniProgramPath}?data=${targetUrlData}`;
            openMpUrl(targetUrl);
          } catch (e) {
            console.error('public-plugin-opener openView openMpUrl fail, err=', e);
          }
          return;
        }
        // todo 迁移登录态逻辑配置到这里
        const passThroughParamsStr = params.paramStr;
        // 处理自定义透传参数的问题
        const paramsArray = passThroughParamsStr?.split('|') ?? [];
        let targetUrl = params.url;
        targetUrl = common.tool.passThroughUrlParam(targetUrl, paramsArray);
        openUrl(targetUrl, params.target);
      },
    };
  },
};

export default openerPlugin;
